import { withJsonFormsControlProps } from '@jsonforms/react';
import { Alert, Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { CustomRendererProps } from '../types';
import { SchemaData } from 'layouts/aplicacoes/Events/hooks/types';

const state = (item: any) => {
  const now = Date.now();
  if (item.active === false) return 'Desativado';
  if (item.availableFrom && Date.parse(item.availableFrom) > now) return 'Futuro';
  if (item.availableUntil && Date.parse(item.availableUntil) < now) return 'Expirado';
  return 'Disponível';
};

function Renderer({ data }: CustomRendererProps<SchemaData>) {
  const modules = [...(((data as any)?.internalContentJSON?.modules) || [])].sort((a: any, b: any) => (a.order || 0) - (b.order || 0));
  return <Stack gap={2} sx={{ mt: 2 }}>
    <Typography variant="h5">Pré-visualização do ambiente do participante</Typography>
    <Typography color="text.secondary">Visualização administrativa; não exige inscrição e não registra acesso.</Typography>
    {!modules.length && <Alert severity="info">Adicione módulos acima para visualizar o ambiente.</Alert>}
    {modules.map((module: any) => <Card variant="outlined" key={module.id || module.title}><CardContent><Stack gap={1}>
      <Stack direction="row" gap={1}><Typography variant="h6">{module.title}</Typography><Chip size="small" label={state(module)} /></Stack>
      {module.description && <Typography>{module.description}</Typography>}
      {[...(module.items || [])].sort((a: any, b: any) => (a.order || 0) - (b.order || 0)).map((item: any) => <Box key={item.id || item.title} sx={{ borderLeft: '3px solid #3754a5', pl: 2, py: 1 }}>
        <Stack direction="row" gap={1}><Typography fontWeight="bold">{item.title}</Typography><Chip size="small" label={item.type} /><Chip size="small" label={state(item)} /></Stack>
        <Typography variant="body2">{item.description}</Typography>
      </Box>)}
    </Stack></CardContent></Card>)}
  </Stack>;
}

export default withJsonFormsControlProps(Renderer);
